var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 5.25V9M2.25 5.25C2.25 7.54838 2.25 12.5807 2.25 12.871C2.25 13.9079 3.70923 14.5243 6.6277 15.7571C7.80015 16.2524 8.38635 16.5 9 16.5V8.5161",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 14.25C11.25 14.25 11.9063 14.25 12.5625 15.75C12.5625 15.75 14.6471 12 16.5 11.25",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24444 7.26853L4.05354 6.20839C2.85118 5.62658 2.25 5.33567 2.25 4.875C2.25 4.41433 2.85118 4.12342 4.05354 3.54161L6.24444 2.48146C7.5966 1.82716 8.27273 1.5 9 1.5C9.72727 1.5 10.4034 1.82715 11.7556 2.48146L13.9465 3.54161C15.1488 4.12342 15.75 4.41433 15.75 4.875C15.75 5.33567 15.1488 5.62658 13.9465 6.20839L11.7556 7.26853C10.4034 7.92285 9.72727 8.25 9 8.25C8.27273 8.25 7.5966 7.92285 6.24444 7.26853Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9L6 9.75",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 3L5.25 6.75",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingIcon);
export default __webpack_public_path__ + "static/media/bookingIcon.2e8f5484aa868c8efbc80aed86420cd0.svg";
export { ForwardRef as ReactComponent };